import { render } from "./EventOccasion.vue?vue&type=template&id=3a270f20"
import script from "./EventOccasion.vue?vue&type=script&lang=js"
export * from "./EventOccasion.vue?vue&type=script&lang=js"

import "./EventOccasion.vue?vue&type=style&index=0&id=3a270f20&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__